import {getConfiguration} from "../config/config";

export const devLogger = (devMessage: string, alternateMessage?: string) : void => {
    if (getConfiguration().isDevelopment) {
        console.log(devMessage);
    } else if (alternateMessage) {
        console.log(alternateMessage);
    }
}